/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs'

const $nsid = 'app.bsky.unspecced.getSuggestedUsersForExplore'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  category: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 50 }),
      25,
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  actors: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
  ),
  recIdStr: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a list of suggested users for the Explore page */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
